module.exports = __webpack_public_path__ + "img/report-4.3cc6872d.jpg";